// @ts-nocheck
import _ from 'lodash';
import { getFileWrapperOaResponseApi } from 'library-@/apis/core_basic_api/patent';
import { Toast } from 'patsnap-biz';
import { getI18nInstance } from '@/locales/i18nInstance';
import { injectService } from '@patsnap/tahiti-core/ioc/inject';
import { PatentBasicService } from '@/domains/patent/services/patent-basic-service';

const i18n = getI18nInstance();
export default class FileWrapperMultiViewService {
    patentId: string = '';

    patent = {};

    nodata: boolean = false;

    multiViewRoundList = [];

    patentBasicService = injectService<PatentBasicService>(PatentBasicService);

    constructor(patentId: string) {
        this.patentId = patentId;
    }

    async init() {
        this.patent = await this.patentBasicService.getPatentBase(this.patentId);
        const apno = _.get(this.patent, 'APN');
        if (!apno) {
            return this.nodata = true;
        }
        const data = await getFileWrapperOaResponseApi({
            patentId: this.patentId,
            apno,
        }).catch((err) => {
            Toast({
                message: err._error_msg || i18n.t('commonStatusCode.400'),
                type: 'error',
                showClose: true,
                dangerouslyUseHTMLString: true,
            });
        });

        this.multiViewRoundList = _.get(data, `${apno}.round_list`, []);
        if (this.multiViewRoundList.length === 0) {
            this.nodata = true;
        }
    }
}
